// Zone type mapping between API format and UI format
export const ZONE_TYPE_MAP = {
  D: "Danger",
  P: "Prohibited",
  R: "Restricted",
} as const;

export const UI_TYPE_TO_API = {
  Danger: "D",
  Prohibited: "P",
  Restricted: "R",
} as const;

export type ZoneTypeCode = keyof typeof ZONE_TYPE_MAP;
export type ZoneTypeLabel = keyof typeof UI_TYPE_TO_API;

export const apiTypeToLabel = (type: string): string => {
  return ZONE_TYPE_MAP[type as ZoneTypeCode] || type;
};

export const labelToApiType = (label: string): string => {
  return UI_TYPE_TO_API[label as ZoneTypeLabel] || label;
};
export const matchesZoneTypeFilter = (
  zoneType: string,
  filterTypes: string[]
): boolean => {
  if (filterTypes.length === 0) return false;
  if (filterTypes.length === 3) return true;

  const zoneLabel = apiTypeToLabel(zoneType);

  return filterTypes.includes(zoneLabel);
};

export const matchesAltitudeRange = (
  zoneUpperLimit: number,
  zoneLowerLimit: number,
  minAltitude: number | null,
  maxAltitude: number | null
): boolean => {
  if (minAltitude === null && maxAltitude === null) return true;

  if (minAltitude !== null && maxAltitude === null) {
    return zoneUpperLimit >= minAltitude;
  }

  if (minAltitude === null && maxAltitude !== null) {
    return zoneLowerLimit <= maxAltitude;
  }

  if (minAltitude !== null && maxAltitude !== null) {
    return zoneLowerLimit <= maxAltitude && zoneUpperLimit >= minAltitude;
  }

  return true;
};
